(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var accordion = function accordion() {
  var accordionToggles = document.querySelectorAll('.accordion__toggle');
  var activeAccordion = null;

  if (accordionToggles) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = accordionToggles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var toggle = _step.value;
        toggle.addEventListener('click', function (e) {
          activeAccordion = e.target.textContent;
          accordionToggles.forEach(function (item) {
            if (item.textContent != activeAccordion) {
              item.parentElement.classList.add('accordion--closed');
            }
          });
          e.target.parentElement.classList.toggle('accordion--closed');
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
};

var _default = accordion;
exports.default = _default;

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var calendar = function calendar() {
  var settings = {
    Color: '',
    LinkColor: '',
    NavShow: true,
    NavVertical: false,
    NavLocation: '',
    DateTimeShow: true,
    DateTimeFormat: 'mmm, yyyy',
    DatetimeLocation: '',
    EventClick: '',
    EventTargetWholeDay: true,
    DisabledDays: []
  };
  var calendarElement = document.getElementById('caleandar');
  var events = [];
  var ourRequest = new XMLHttpRequest();
  ourRequest.open('GET', '/wp-json/wp/v2/events');

  ourRequest.onload = function () {
    if (ourRequest.status >= 200 && ourRequest.status < 400) {
      var data = JSON.parse(ourRequest.responseText);
      var filteredByLangData = null;

      if (currentLang == 'en') {
        filteredByLangData = data.filter(function (event) {
          return event.link.includes('/en/');
        });
      } else if (currentLang == 'ru') {
        filteredByLangData = data.filter(function (event) {
          return event.link.includes('/ru/');
        });
      } else {
        filteredByLangData = data.filter(function (event) {
          return !event.link.includes('/en/') && !event.link.includes('/ru/');
        });
      }

      filteredByLangData.forEach(function (event) {
        var date = event.acf.date.split('/');
        events.push({
          Date: new Date(parseInt(date[2]), parseInt(date[1]) - 1, parseInt(date[0])),
          Title: event.title.rendered,
          Link: event.link
        });
      });
      caleandar(calendarElement, events, settings);
    } else {
      console.log('We connected to the server, but it returned an error.');
    }
  };

  ourRequest.onerror = function (e) {
    console.log('Connection error', e);
  };

  ourRequest.send();
};

var _default = calendar;
exports.default = _default;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accessibility = exports.search = exports.menu = exports.fixedHeader = void 0;

var _helpers = require("../helpers");

var fixedHeader = function fixedHeader() {
  var header = document.querySelector('.header');
  window.addEventListener('scroll', function () {
    if (window.pageYOffset > 250) {
      header.classList.add('header--fixed');
    } else {
      header.classList.remove('header--fixed');
    }
  });
};

exports.fixedHeader = fixedHeader;

var menu = function menu() {
  if ((0, _helpers.isMobile)()) {
    var burger = document.querySelector('[data-burger]');
    burger.addEventListener('click', function () {
      document.body.classList.toggle('nav-active');
    });
    var menuWrapper = document.querySelector('.header__nav__menu');
    var subMenus = document.querySelectorAll('.sub-menu');
    var currentSubmenuOpened = null;
    menuWrapper.addEventListener('click', function (e) {
      if (e.target.parentElement.classList.contains('menu-item-has-children')) {
        e.preventDefault();

        if (e.target.parentElement.parentElement.classList.contains('header__nav__menu')) {
          subMenus.forEach(function (subMenu) {
            subMenu.parentElement.classList.remove('sub-menu-visible');
          });
        }

        if (e.target.parentElement.classList.contains('menu-item-has-children')) {
          if (currentSubmenuOpened !== e.target.text) {
            currentSubmenuOpened = e.target.text;
            e.target.parentElement.classList.add('sub-menu-visible');
          } else {
            e.target.parentElement.classList.remove('sub-menu-visible');
            currentSubmenuOpened = null;
          }
        }
      }
    });
  }
};

exports.menu = menu;

var search = function search() {
  var searchInput = document.querySelector('[data-search-input]');
  var searchResults = document.querySelector('.search-results');
  var searchWrapper = document.querySelector('.header__main__search');
  var searchClear = document.querySelector('.clear-button');
  searchInput.addEventListener('keyup', function (e) {
    if (searchInput.value.length > 2) {
      var ourRequest = new XMLHttpRequest();
      ourRequest.open('POST', '/wp-admin/admin-ajax.php', true);
      ourRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");

      ourRequest.onreadystatechange = function () {
        if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
          if (this.response) {
            searchResults.innerHTML = this.response;
            searchWrapper.classList.add('header__main__search--has-items');
          }
        }
      };

      ourRequest.send("action=get_ajax_posts&search=".concat(searchInput.value));
    } else {
      searchWrapper.classList.remove('header__main__search--has-items');
      searchResults.innerHTML = '';
    }
  });
  searchClear.addEventListener('click', function () {
    searchWrapper.classList.remove('header__main__search--has-items');
    searchResults.innerHTML = '';
    searchInput.value = '';
  });
};

exports.search = search;

var accessibility = function accessibility() {
  var contrastToggle = document.querySelector('.contrast-toggle');
  var fontSizeSwitcherWrapper = document.querySelector('.font-size-nav');
  var activeContrast = (0, _helpers.getCookie)('contrast');

  if (activeContrast && activeContrast == 'true') {
    document.body.classList.toggle('high-contrast');
  } else {
    activeContrast = false;
  }

  contrastToggle.addEventListener('click', function () {
    activeContrast = (0, _helpers.getCookie)('contrast');

    if (activeContrast == 'true') {
      document.body.classList.remove('high-contrast');
      (0, _helpers.setCookie)('contrast', 'true', 0);
    } else {
      document.body.classList.add('high-contrast');
      (0, _helpers.setCookie)('contrast', 'true', 7);
    }
  });
  fontSizeSwitcherWrapper.addEventListener('click', function (e) {
    if (e.target.dataset.fontSize) {
      document.body.classList.remove('font-smaller');
      document.body.classList.remove('font-normal');
      document.body.classList.remove('font-bigger');
      document.body.classList.add("font-".concat(e.target.dataset.fontSize));
    }
  });
};

exports.accessibility = accessibility;

},{"../helpers":6}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sliders = void 0;

var sliders = function sliders() {
  if (document.querySelector('.hero-slider')) {
    tns({
      container: '.hero-slider',
      items: 1,
      controlsText: ['', ''],
      nav: false
    });
  }

  if (document.querySelector('.news__grid')) {
    tns({
      container: '.news__grid',
      items: 1,
      controlsText: ['', ''],
      nav: false,
      autoHeight: true,
      mouseDrag: true,
      responsive: {
        1024: {
          disable: true
        }
      }
    });
  }

  if (document.querySelector('.partners__grid')) {
    tns({
      container: '.partners__grid',
      items: 1,
      controlsText: ['', ''],
      nav: false,
      gutter: 25,
      autoHeight: true,
      mouseDrag: true,
      responsive: {
        480: {
          items: 2
        },
        768: {
          items: 3
        },
        1024: {
          items: 5
        }
      }
    });
  }
};

exports.sliders = sliders;

},{}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var API_URL = 'https://api.wsfiz.edu.pl';
var postsContainer = document.querySelector('.recto-posts'); // Pagination options

var postPerPage = 10;
var currentPage = 0;

var getArticles = function getArticles() {
  if (postsContainer) {
    getArticlesRequest(); // Load more button event click

    postsContainer.addEventListener('click', function (e) {
      if (e.target.classList.contains('recto-posts__more')) {
        getArticlesRequest();
        e.target.remove();
      }
    });
  }
};

var getArticlesRequest = function getArticlesRequest() {
  var code = postsContainer.dataset.code;
  var ourRequest = new XMLHttpRequest();
  ourRequest.open('GET', "".concat(API_URL, "/Aktualnosci/").concat(code, "?skip=").concat(currentPage * postPerPage, "&take=").concat(postPerPage));

  ourRequest.onload = function () {
    if (ourRequest.status >= 200 && ourRequest.status < 400) {
      var data = JSON.parse(ourRequest.responseText);
      currentPage++; // Add posts

      data.newsPage.forEach(function (post) {
        var postHtml = "<div class=\"recto-posts__item\">";
        postHtml += "\n          <span class=\"recto-posts__item__date\">".concat(post.datastr, "</span>\n          <h3 class=\"recto-posts__item__title\">").concat(post.naglowek, "</h3>\n        ");

        if (post.opis) {
          postHtml += "\n          <div class=\"recto-posts__item__text\">\n            ".concat(post.opis, "\n          </div>\n        ");
        }

        if (post.attachmentId) {
          postHtml += "<h4 class=\"recto-posts__item__file-label\">Za\u0142\u0105cznik</h4>";
          postHtml += "<a href=\"https://api.wsfiz.edu.pl/Download/".concat(post.sid, "\" class=\"recto-posts__item__file\">").concat(post.dostep, "</a>");
        }

        postHtml += "</div>";
        postsContainer.insertAdjacentHTML('beforeend', postHtml);
      }); // Show more button

      if (data.newsCount - currentPage * postPerPage > 0) {
        var buttonMoreHtml = "<button class=\"recto-posts__more button\">Poka\u017C wi\u0119cej</button>";
        postsContainer.insertAdjacentHTML('beforeend', buttonMoreHtml);
      }
    } else {
      console.log('We connected to the server, but it returned an error.');
    }
  };

  ourRequest.onerror = function (e) {
    console.log('Connection error', e);
  };

  ourRequest.send();
};

var _default = getArticles;
exports.default = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCookie = exports.setCookie = exports.isMobile = void 0;

var isMobile = function isMobile() {
  return window.innerWidth <= 1024 ? true : false;
};

exports.isMobile = isMobile;

var setCookie = function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

exports.setCookie = setCookie;

var getCookie = function getCookie(cname) {
  var name = cname + "=";
  var ca = document.cookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
};

exports.getCookie = getCookie;

},{}],7:[function(require,module,exports){
"use strict";

var _helpers = require("./helpers");

var _header = require("./components/header");

var _home = require("./components/home");

var _calendar = _interopRequireDefault(require("./components/calendar"));

var _accordion = _interopRequireDefault(require("./components/accordion"));

var _recto = _interopRequireDefault(require("./components/recto"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _header.menu)();
(0, _header.search)();
(0, _header.accessibility)();
(0, _accordion.default)();

if (document.querySelector('.recto-posts')) {
  (0, _recto.default)();
}

if (!(0, _helpers.isMobile)()) {
  (0, _header.fixedHeader)();
}

if (document.body.classList.contains('home')) {
  (0, _home.sliders)();
}

if (document.getElementById('caleandar')) {
  (0, _calendar.default)();
}

if (document.querySelector('.fc-gallery-slider')) {
  tns({
    container: '.fc-gallery-slider',
    items: 1,
    controlsText: ['', ''],
    nav: false,
    gutter: 25,
    autoHeight: true,
    mouseDrag: true,
    responsive: {
      480: {
        items: 2
      },
      768: {
        items: 3
      }
    }
  });
}
/** Animations */


if (document.body.classList.contains('page-template-template-history')) {
  AOS.init();
}

},{"./components/accordion":1,"./components/calendar":2,"./components/header":3,"./components/home":4,"./components/recto":5,"./helpers":6}]},{},[7]);
